<template>
  <div class="navbar">
    <div
      class="title"
      :style="isMenuShow ? 'text-align:left' : 'text-align:center'"
    >
      <img :src="logo" />
    </div>
    <div class="open-menu-icon">
      <Icon type="md-menu" @click="showMenu()" />
    </div>
    <transition name="fade">
      <div class="menu" @click="closeMenu" v-show="isMenuShow === true">
        <menu-list ref="menuList" :bind="$attrs" v-on="$listeners"></menu-list>
      </div>
    </transition>
  </div>
</template>
<script>
import menuList from "./menu-list";
import { logo } from "../../images/menu/index";

export default {
  data() {
    return {
      isMenuShow: false,
      logo,
    };
  },
  components: {
    menuList,
  },
  props: ["pageIndex"],
  methods: {
    showMenu() {
      this.isMenuShow = true;
      setTimeout(() => {
        this.$refs.menuList.init();
      }, 100);
    },

    closeMenu() {
      setTimeout(() => {
        this.isMenuShow = false;
      }, 100);
      this.$refs.menuList.close();
    },
  },
};
</script>
<style scoped>
.navbar {
  width: 100%;
  height: 3rem;
  /* padding-top: 1.5rem; */
  background: #333333;
  font-weight: bold;
  color: #fff;
  /* font-size: 1rem; */
  /* padding-bottom: 0.5rem; */
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 998;
}

.title {
  text-align: center;
  line-height: 1rem;
  width: 6rem;
  height: 2.4rem;
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -3rem;
  margin-top: -1.2rem;
  border-radius: 10%;
  transition: all 0.5s;
}

.title img {
  width: 100%;
  height: auto;
  margin: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -3rem;
  margin-top: -0.7rem;
}

.open-menu-icon {
  position: absolute;
  font-size: 1.5rem;
  right: 1rem;
  top: 50%;
  margin-top: -1rem;
}

.menu {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  z-index: 999;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/pe-home/modules/navbar.vue